import { I9FormLocationResponseDto } from '../dto/res/I9FormLocationResponseDto';
import { I9FormLocation } from '../../../application/domain/entities/I9FormLocation';

/**
 * Maps the I9FormLocation API response DTO to the domain entity
 */
export function mapI9FormLocationDtoToEntity(dto: I9FormLocationResponseDto): I9FormLocation {
  return {
    locationId: dto.locationId,
    name: dto.name,
    state: dto.state,
    isRemoteLocation: dto.isRemoteLocation,
    isEverifyEnable: dto.isEverifyEnable,
    isEmployeeFillingDocs: dto.isEmployeeFillingDocs,
  };
}
